import { render, staticRenderFns } from "./FiltroStatusPedido.vue?vue&type=template&id=741753a6&"
import script from "./FiltroStatusPedido.vue?vue&type=script&lang=js&"
export * from "./FiltroStatusPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports